function Spinner({ className = "" }) {
  return (
    <div
      className={`spinner-border text-primary shrink-0 ${className}`}
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default Spinner;
